import { testSessionStore } from './test-session-store'
import { visualReplayStore } from './visual-replay-store'
import { getIssueBusinessContext } from '../diagnostics/issue-package-context'

type BuildInfo = { commit: string; mode: string }

function getCurrentRoute(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

function getBuildInfo(): BuildInfo {
  return (window as Window & { __BUILD_INFO__?: BuildInfo }).__BUILD_INFO__ ?? { commit: 'dev', mode: 'development' }
}

export function startTestSession(): void {
  const route = getCurrentRoute()
  testSessionStore.start({ route, build: getBuildInfo(), context: getIssueBusinessContext(route) })
  void visualReplayStore.start()
}

export function endTestSession(): void {
  testSessionStore.end(Date.now(), getCurrentRoute())
  visualReplayStore.stop()
}
